/**
 * Collapsible "Nápověda k MVL" cheat-sheet rendered directly below the MVL
 * expression editor (CZNA-245). Concise, cataloguer-facing reference for the
 * functions / operators / conventions the live `validation/mvl/assist`
 * completion list exposes (the authoritative source of truth). Collapsed by
 * default so it never crowds the form.
 */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { AccordionSet, Accordion } from '@folio/stripes/components';
var codeStyle = {
    fontFamily: 'monospace',
    fontSize: '0.85em',
    whiteSpace: 'pre-wrap',
};
var sectionStyle = { marginBottom: '0.75rem' };
var headingStyle = { fontWeight: 600, marginBottom: '0.25rem' };
var listStyle = { margin: 0, paddingLeft: '1.25rem' };
var MvlHelpPanel = function () {
    var intl = useIntl();
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var t = function (id) { return intl.formatMessage({ id: "ui-czna-authorities.validationRules.mvlHelp.".concat(id) }); };
    return (React.createElement(AccordionSet, null,
        React.createElement(Accordion, { id: "mvl-help-accordion", label: t('title'), open: open, onToggle: function () { return setOpen(function (o) { return !o; }); } },
            React.createElement("div", { "data-testid": "mvl-help-content", style: { fontSize: '0.9em' } },
                React.createElement("div", { style: sectionStyle },
                    React.createElement("div", { style: headingStyle }, t('functions.heading')),
                    React.createElement("ul", { style: listStyle },
                        React.createElement("li", null,
                            React.createElement("span", { style: codeStyle }, t('functions.field'))),
                        React.createElement("li", null,
                            React.createElement("span", { style: codeStyle }, t('functions.sub'))),
                        React.createElement("li", null,
                            React.createElement("span", { style: codeStyle }, t('functions.count'))),
                        React.createElement("li", null,
                            React.createElement("span", { style: codeStyle }, t('functions.value'))),
                        React.createElement("li", null,
                            React.createElement("span", { style: codeStyle }, t('functions.length'))))),
                React.createElement("div", { style: sectionStyle },
                    React.createElement("div", { style: headingStyle }, t('operators.heading')),
                    React.createElement("div", { style: codeStyle }, t('operators.logical')),
                    React.createElement("div", { style: codeStyle }, t('operators.comparison'))),
                React.createElement("div", { style: sectionStyle },
                    React.createElement("div", { style: headingStyle }, t('conventions.heading')),
                    React.createElement("div", null, t('conventions.text'))),
                React.createElement("div", { style: sectionStyle },
                    React.createElement("div", { style: headingStyle }, t('examples.heading')),
                    React.createElement("ul", { style: listStyle },
                        React.createElement("li", null,
                            React.createElement("span", { style: codeStyle }, t('examples.one'))),
                        React.createElement("li", null,
                            React.createElement("span", { style: codeStyle }, t('examples.two'))),
                        React.createElement("li", null,
                            React.createElement("span", { style: codeStyle }, t('examples.three')))))))));
};
export default MvlHelpPanel;
